// Error codes for the frontend (not backend error codes)

export const errors = {
  UNEXPECTED_ERROR: 1234,
  NETWORK_ERROR_TITLE: 'networkErrorTitle'
};
